if (!customElements.get('cbm-marquee')) {
  class CbmMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cbm-track]');
      this.group = this.querySelector('[data-cbm-group]');
      this.toggle = this.querySelector('[data-cbm-toggle]');
      this.speed = Number(this.dataset.speed) || 40;
      this.animated = this.dataset.mode === 'marquee' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onClick = this.onClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      if (this.animated && this.track && this.group) {
        if (this.querySelector('[data-cbm-toggle]') && sessionStorage.getItem('cbm-marquee-paused') === 'true') this.setPaused(true);
        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this);
        this.layout();
      }

      if (this.hasAttribute('data-sticky')) {
        this.heightObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--cbm-ann-h', `${this.offsetHeight}px`);
        });
        this.heightObserver.observe(this);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.heightObserver) {
        this.heightObserver.disconnect();
        document.documentElement.style.removeProperty('--cbm-ann-h');
      }
    }

    // Clones the message group until the strip is at least twice the viewport wide, so the loop never shows a gap.
    layout() {
      const groupWidth = this.group.getBoundingClientRect().width;
      if (!groupWidth) return;
      const needed = Math.max(2, Math.ceil((this.clientWidth * 2) / groupWidth) + 1);
      const clones = this.track.querySelectorAll('[data-cbm-clone]');

      if (clones.length + 1 !== needed) {
        clones.forEach((clone) => clone.remove());
        for (let i = 1; i < needed; i++) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-cbm-group');
          clone.setAttribute('data-cbm-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }
      }

      this.style.setProperty('--cbm-shift', `-${groupWidth}px`);
      this.style.setProperty('--cbm-duration', `${(groupWidth / this.speed).toFixed(2)}s`);
      this.classList.add('is-animated');
    }

    setPaused(paused) {
      this.classList.toggle('is-paused', paused);
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
    }

    onClick(event) {
      if (event.target.closest('[data-cbm-toggle]')) {
        const paused = !this.classList.contains('is-paused');
        this.setPaused(paused);
        sessionStorage.setItem('cbm-marquee-paused', String(paused));
        return;
      }

      const copy = event.target.closest('[data-cbm-copy]');
      if (copy) {
        const code = copy.dataset.cbmCopy;
        const done = () => {
          copy.classList.add('is-copied');
          setTimeout(() => copy.classList.remove('is-copied'), 1600);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      }
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      this.classList.add('is-editing');
    }

    onBlockDeselect(event) {
      if (!this.contains(event.target)) return;
      this.classList.remove('is-editing');
    }
  }

  customElements.define('cbm-marquee', CbmMarquee);
}
